import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { UserFinance } from "../_models/userFinance";
import { ItemFinance } from "../_models/itemFinance";
import { DocumentNumbering } from "../_models/documentNumbering";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { AccountItem } from "../_models/accountItems";
import { Account } from "../_models/account";
import { Exchangerate } from "../_models/exchangerate";
import { Invoices } from "../_models/invoices";
import { AccountStatement } from "../_models/accountStatemet";
import { BankStatementItem } from "../_models/bankStatementItem";
import { Observable } from "rxjs";
import { GenetarePdfForm } from "../_models/generatePdfForm";
import { FinancialAccount } from "../_models/financial-account";
import { OpenIntemTableData } from "../_models/open-item-tabel-data";
import { BookkeepingClients } from "../_models/bookkeeping-clients";


import { LanguageType } from "../_models/financemailwarning";
import { FinanceInvoiceListResponse } from "../pages/admin/display-all-finance-account/models/invoiceList.response.model";
import { CreateFinanceClientRequest } from 'src/app/pages/admin/add-client-finance/models/createFinanceClient.request.model';
import { UpdateFinanceClientRequest } from "../pages/admin/add-client-finance/models/updateFinanceClient.request.model";


@Injectable({
    providedIn: `root`
})

export class FinanceService {
    
    baseUrl = environment.apiUrl;
    private itemData = new BehaviorSubject<any[]>([]);
    currentData = this.itemData.asObservable();
    private dateData = new BehaviorSubject<any[]>([]);
    currentDataDate =  this.dateData.asObservable();
    private datePrices = new BehaviorSubject<any[]>([]);
    currentDataPrices =  this.datePrices.asObservable();
   


    private invoiceSubject = new BehaviorSubject<any>({});
    invoiceData =this.invoiceSubject.asObservable();

    private invoiceIdSubject = new BehaviorSubject<any>(null);
    invoiceId =this.invoiceIdSubject.asObservable();

    constructor(private http: HttpClient) {}

    sendInvoiceID(id: number,print: boolean) {
        this.invoiceIdSubject.next({id: id, print: print});
   
    }
    sendInvoiceToDisplay(account: any) {
        this.invoiceSubject.next(account);
   
    }



    addUser(request: CreateFinanceClientRequest) {
       
        return this.http.post(this.baseUrl + 'finance/add', request);
       
      }
    addItem(item:ItemFinance) {
        
        return this.http.post(this.baseUrl + 'finance/addItem', item);
       
    }
    getNextPassword(){
        return this.http.get(this.baseUrl + 'finance/nextPassword');
    }
    getAllClients(){
        return this.http.get<UserFinance[]>(this.baseUrl + 'finance/bussines-client');
    }
    getAllItems(){
        return this.http.get<ItemFinance[]>(this.baseUrl + 'finance/bussines-item');
    }
    deleteClientFinanceById(id:number){
        return this.http.delete<UserFinance>(this.baseUrl + `finance/${id}`);
    }
    deleteItemById(id:number){
        return this.http.delete<ItemFinance>(this.baseUrl + `finance/item/${id}`);
    }
    getClientFinance(id:number){
        return this.http.get<UserFinance>(this.baseUrl + `finance/client-finance/${id}`);
    }
    getItemFinance(id:number){
        return this.http.get<ItemFinance>(this.baseUrl + `finance/item-finance/${id}`);
    }
    editUser(user: UpdateFinanceClientRequest,id:number) {
        
        return this.http.put<UserFinance>(this.baseUrl + `finance/edit/${id}`, user);   
      }
    editItem(item: ItemFinance,id:number) {
        
        return this.http.put<ItemFinance>(this.baseUrl + `finance/edit-item/${id}`, item);   
      }
    editDocument(document: DocumentNumbering,id:number) {
        
        return this.http.put<DocumentNumbering>(this.baseUrl + `finance/edit-document/${id}`, document);   
      }
    addDocument(document:DocumentNumbering) {

        return this.http.post<DocumentNumbering>(this.baseUrl + 'finance/addDocument', document);   
    }
    addAccount(account:Account){
        return this.http.post<number>(this.baseUrl + 'finance/addAccountItem', account);
    }

    getNextPasswordDocumentation(){
        return this.http.get(this.baseUrl + 'finance/nextPasswordDocument');
    }
    getAllDocuments(){
        return this.http.get<DocumentNumbering[]>(this.baseUrl + 'finance/all-documents');
    }
    deleteDocumentById(id:number){
        return this.http.delete<DocumentNumbering>(this.baseUrl + `finance/delete-document/${id}`);
    }
    getDocument(id:number){
        return this.http.get<DocumentNumbering>(this.baseUrl + `finance/document/${id}`);
    }
    sendItem(data: any[]) {
        this.itemData.next(data);
   
      }
    sendDate(data: any[]) {
        this.dateData.next(data);
      }
    sendPrices(data: any[]) {
        this.datePrices.next(data);
       
      }
    deleteAccount(itemId:number){
        return this.http.delete(this.baseUrl + `finance/deleteAccount/${itemId}`);
    }
    addExchangeRate(ex:Exchangerate){
        return this.http.post<Exchangerate>(this.baseUrl + 'finance/addExchangerate', ex);
    }
    getAllExchangerate(){
        return this.http.get<Exchangerate[]>(this.baseUrl + 'finance/all-exchangerate');
    }
    getAllAccounts(){
        // Invoice
        return this.http.get<FinanceInvoiceListResponse[]>(this.baseUrl + 'finance/all-accounts');
    }
    
    getClientsListForGpsClients(){
        return this.http.get<ItemFinance[]>(this.baseUrl + 'finance/bussines-client-for-gps-clients');
    }
    getClientsByPib(pib:string){
        return this.http.get<UserFinance>(this.baseUrl + `finance/get-bussines-client-by-pib/${pib}`);
    }
    exportExcelById(id: number) {
        return this.http.get<any>(this.baseUrl + `finance/exportExcel/${id}`);
    }
    exportAccountsExcel(object:any) {
        return this.http.post<any>(this.baseUrl + `finance/exportAccountsExcel`,object);
    }   
    // getAllItemsByAccountId(customerId:number,accountId:number){
    //     return this.http.get<AccountItem>(this.baseUrl + `finance/items/${customerId}/${accountId}`);
    // }
    createGeneratePdfForm(pdfForm:any){
        return this.http.post<any>(this.baseUrl + 'finance/addGeneratePdfForm',pdfForm);
    }
    getGeneratePdf(){
        return this.http.get<GenetarePdfForm>(this.baseUrl + 'finance/generatePdfForm');
    }
    exportClientsExcel(object:any) {
        return this.http.post<any>(this.baseUrl + `finance/exportClientsExcel`,object);
    } 
    getTaxRates(){
        return this.http.get<any>(this.baseUrl + `finance/taxRates`);
    }  
    getInvoiceTypes(){
        return this.http.get<any>(this.baseUrl + `finance/invoice-type-info`);
    }  
    getInvoicePeriodCodesInfo(){
        return this.http.get<any>(this.baseUrl + `finance/invoice-period-codes-info`);
    }  
    getTaxCodesBasis(){
        return this.http.get<any>(this.baseUrl + `finance/tax-codes-basis`);
    } 
    addFinancialAccounts(financialAccounts:FinancialAccount[]) {
        return this.http.post(this.baseUrl + 'finance/addEditFinancialAccounts', financialAccounts);
    } 
    getFinancialAccounts() {
        return this.http.get(this.baseUrl + 'finance/getFinancialAccounts');
    } 
    getInvoiceDataByAccountId(invoiceId:number){
        return this.http.get<any>(this.baseUrl + `finance/invoiceData/${invoiceId}`);
    }
    getInvoiceDataForEditByAccountId(invoiceId:number){
        return this.http.get<any>(this.baseUrl + `finance/getInvoiceDataForEdit/${invoiceId}`);
    }
    editInvoice(account:Account,invoiceId:number){
        return this.http.post<number>(this.baseUrl + `finance/editInvoicData/${invoiceId}`, account);
    }
    sendInvoiceToEInvoiceAPI(invoiceId:number){
        return this.http.get<any>(this.baseUrl + `finance/sendInvoiceToApi/${invoiceId}`);
    }
    stornoInvoiceToEInvoiceAPI(invoiceId:number,stornoText:string){
        return this.http.get<any>(this.baseUrl + `finance/stornoInvoice/${invoiceId}/${stornoText}`);
    }

    bookInvoiceApprovalToEInvoiceApi(invoiceId: number, bookAprovalText: string) {
        return this.http.get<any>(
            this.baseUrl + `finance/bookInvoiceAppproval/${invoiceId}/${bookAprovalText}`);
    }

    getInvoiceDocumentReference(){
        return this.http.get<AccountItem>(this.baseUrl + `finance/invoice-document-reference`);
    }
    addNewFile(xmldata: FormData, args: { fileName, contentType }) {  
        return this.http.post(this.baseUrl + 'finance/addNewFile', xmldata, {
            params: {
                searchOptions: JSON.stringify(args || {})
            }
        });  
    }
    getAllBankStatement(){
        return this.http.get<AccountStatement[]>(this.baseUrl + 'finance/all-bank-statement');
    }
    getAllBankStatementItem(){
        return this.http.get<BankStatementItem[]>(this.baseUrl + 'finance/all-bank-statement-item');
    }
    getBankStatementItem(){
        return this.http.get<AccountStatement[]>(this.baseUrl + 'finance/bank-statement');
    }
    addNewFileHalk(xmldata: FormData, args: { fileName, contentType }) {  
        return this.http.post(this.baseUrl + 'finance/addNewFileHalk', xmldata, {
            params: {
                searchOptions: JSON.stringify(args || {})
            }
        });  
    }

    sendInvoiceToEmail(invoiceId:number){
        
        return this.http.get<any>(this.baseUrl + `finance/sendInvoiceToEmail/${invoiceId}`);
    }
    stornoInvoiceEmail(invoiceId:number){
        
        return this.http.get<any>(this.baseUrl + `finance/stornoEmailInvoice/${invoiceId}`);
    }
    getAllBankStatementItemById(id:number){
        return this.http.get<BankStatementItem[]>(this.baseUrl + `finance/bank-statement-items-id/${id}`);
    }

    getBankStatementItemsByHeaderId(bankStatementHeaderId: number) {
        return this.http.get<any[]>(`${this.baseUrl}` + `finance/bankStatementHeaders/${bankStatementHeaderId}/items`);
    }

    exportBankStatementFileByHeaderId(bankStatementHeaderId: number) {
        return this.http.get<any>(this.baseUrl + `finance/bankStatementHeaders/${bankStatementHeaderId}/uploadedFile/export`);
    }

    deleteBankStatementByHeaderId(bankStatementHeaderId: number) {
        return this.http.delete<any>(
            this.baseUrl + `finance/bank-statement/${bankStatementHeaderId}/delete`);
    }

    editBankItem(id:number,name: number){    
        return this.http.put<UserFinance>(this.baseUrl + `finance/edit-bank-statement/${id}`,name);   
    }
   
    getBookkeepingOpenItemsTableData(filter:any){
        return this.http.get<OpenIntemTableData[]>(this.baseUrl + 'finance/open-items-data', {
            params: {
                filter: JSON.stringify(filter || {})
            }
        }
        );
    }
    getBookkeepingOpenItemsStartState(pib:string){
        return this.http.get<number>(this.baseUrl + `finance/open-items-client-start-state/${pib}` );
    }
    getBookkeepingOpenItemsDetailView(filter:any){
        return this.http.get<any>(this.baseUrl + 'finance/open-items-data-detail-view-test', {
            params: {
                filter: JSON.stringify(filter || {})
            }
        }
        );
    }
    getBookkeepingClientsTableData(filter:any){
        return this.http.get<any[]>(this.baseUrl + 'finance/bookkeeping-clients-detail-view-test', {
            params: {
                filter: JSON.stringify(filter || {})
            }
        }
        );
    }
    getBookkeepingClientsDetailView(filter:any){
        return this.http.get<any>(this.baseUrl + 'finance/bookkeeping-clients-detail-view', {
            params: {
                filter: JSON.stringify(filter || {})
            }
        }
        );
    }
    getBankStatementById(id:number){
        return this.http.get<any[]>(this.baseUrl + `finance/bank-statement-id/${id}`);
    }
    exportBankStatementExcel(id:number) {
        return this.http.get<any>(this.baseUrl + `finance/exportBankStatementExcel/${id}`);
    } 
    exportBankStatementPdf(id:number) {
        return this.http.get<any>(this.baseUrl + `finance/exportBankStatementPdf/${id}`);
    } 
    deleteAttachment(id: number) {
        return this.http.delete<any>(this.baseUrl + `finance/delete-invoice-attachment/${id}`);
    }
    downloadAttachment(id: number) {
        return this.http.get<any>(this.baseUrl + `finance/download-invoice-attachment/${id}`, { responseType: 'arraybuffer' as 'json' });
    }
    downloadZipAttachments(invoiceId: number) {
        return this.http.get(this.baseUrl + `finance/download-zip-invoice-attachment/${invoiceId}`, {
          responseType: 'arraybuffer',
        });
      }
    uploadAttachment(formData:any){
        return this.http.post<any>(this.baseUrl + `finance/upload-invoice-attachment`, formData, {
            headers: this._fileHttpHeaders(),
        });
    }
    private _fileHttpHeaders(): HttpHeaders {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'multipart/form-data');
        headers.append('Accept', 'application/json');
        return headers;
    }
    getBankBalance(){
        return this.http.get<any[]>(this.baseUrl + `finance/all-bankBalance`);
    }
    getBankBalanceByDate(date:Date){
        return this.http.get<any[]>(this.baseUrl + `finance/all-bankBalance-date/${date}`);
    }
    addEmailText(emailText:any) {  
       
        return this.http.post(this.baseUrl + 'finance/addEditEmailText', emailText);  
    }
    getFinanceEmailText(type:LanguageType){
        return this.http.get<any>(this.baseUrl + `finance/language/${type}`);
    }
    getAllTagsByClientId(id:number){
        return this.http.get<any[]>(this.baseUrl + `finance/tagsByClientId/${id}`);
    }
    exportPdfClientTagInformation(id:number) {
        return this.http.get<any>(this.baseUrl + `finance/exportPdfClientTagInformation/${id}`);
    } 
    accountDeactivationSuggestionsList() {
        return this.http.get<any>(this.baseUrl + `finance/account-deactivation-suggestions`);
    }

    exportExcelForAccountDeactivationSuggestions() {
        return this.http.get<any>(this.baseUrl + `finance/account-deactivation-suggestions/excel/export`);
    }

    getNumberOfClientsByMonth(){
        return this.http.get<any>(this.baseUrl + `finance/statistic/number-of-clients-by-month`);
    }
    getNumberOfDocumentsByMonth(){
        return this.http.get<any>(this.baseUrl + `finance/statistic/number-of-document-by-month`);
    }

    getStatisticsForClientSummaries(request: { month, year }) {
        return this.http.get<any[]>(this.baseUrl + `finance/statistic/clientSummaries`, {
            params: {
                searchOptions: JSON.stringify(request || {})
            }
        });
    }
    
    searchCompanyByPibFormNbsApi( pib:string) {
        return this.http.get<any>(this.baseUrl + `finance/search-company-by-pib-from-nbs-api/${pib}`);
    }
    exportExelClientTagInformation(id:number) {
        return this.http.get<any>(this.baseUrl + `finance/exportExelClientTagInformation/${id}`);
    } 
    addNewFileIntesa(xmldata: FormData, args: { fileName, contentType }) {  
        return this.http.post(this.baseUrl + 'finance/addNewFileIntesa', xmldata, {
            params: {
                searchOptions: JSON.stringify(args || {})
            }
        });  
    }
    addNewFileAddico(xmldata: FormData, args: { fileName, contentType }) { 
        return this.http.post(this.baseUrl + 'finance/addNewFileAddico', xmldata, {
            params: {
                searchOptions: JSON.stringify(args || {})
            }
        });  
    }
    
    addNewFileUniCredit(xmldata: FormData, args: { fileName, contentType }) {  
        return this.http.post(this.baseUrl + 'finance/addNewFileUniCredit', xmldata, {
            params: {
                searchOptions: JSON.stringify(args || {})
            }
        });  
    }
    addItemOfBankStatment(object:any,id: number){    
        return this.http.post<any>(this.baseUrl + `finance/addNewBankItem/${id}`,object);   
    }
    addNewFileHalkDev(xmldata: FormData, args: { fileName, contentType }) {  
        return this.http.post(this.baseUrl + 'finance/addNewFileHalkDev', xmldata, {
            params: {
                searchOptions: JSON.stringify(args || {})
            }
        });  
    }
}
